module.exports = __webpack_public_path__ + "static/media/Icon-routine.3ca2f165.svg";